import { HotelAvailabilityErrors, } from '@honeycomb/data';
import { DEFAULT_HOTEL_BASKET } from './HotelBasketContext';
export var HotelBasketActionType;
(function (HotelBasketActionType) {
    HotelBasketActionType["SET_SELECTED_ROOM"] = "set-selected-rooms";
    HotelBasketActionType["SET_SELECTED_FLIGHT"] = "set-selected-flight";
    HotelBasketActionType["SET_TRIP_STATE_ID"] = "set-trip-state-id";
    HotelBasketActionType["SET_HOTEL_CHECK_IN_DATE"] = "set-hotel-check-in-date";
    HotelBasketActionType["RESET_CONTEXT"] = "reset-context";
    HotelBasketActionType["SET_AVAILABILITY_ERRORS"] = "set-availability-errors";
    HotelBasketActionType["REMOVE_AVAILABILITY_ERRORS"] = "remove-availability-errors";
    HotelBasketActionType["SET_WAITING_FOR_FLIGHT"] = "set-waiting-for-flight";
    HotelBasketActionType["SET_WAITING_FOR_ROOM"] = "set-waiting-for-room";
    HotelBasketActionType["SET_ROOM_NOT_AVAILABLE"] = "set-room-not-available";
})(HotelBasketActionType || (HotelBasketActionType = {}));
export function hotelBasketReducer(state, action) {
    var _a;
    switch (action.type) {
        case HotelBasketActionType.SET_SELECTED_ROOM:
            return Object.assign(Object.assign({}, state), { selectedRooms: action.payload.selectedRooms, automaticRoomSelection: (_a = action.payload.automaticRoomSelection) !== null && _a !== void 0 ? _a : false, waitingForRooms: false });
        case HotelBasketActionType.SET_SELECTED_FLIGHT:
            return Object.assign(Object.assign({}, state), { selectedFlight: action.payload, waitingForFlights: false });
        case HotelBasketActionType.SET_TRIP_STATE_ID:
            return Object.assign(Object.assign({}, state), { tripStateId: action.payload });
        case HotelBasketActionType.SET_HOTEL_CHECK_IN_DATE:
            return Object.assign(Object.assign({}, state), { hotelCheckInDate: action.payload });
        case HotelBasketActionType.SET_WAITING_FOR_ROOM:
            return Object.assign(Object.assign({}, state), { waitingForRooms: action.payload });
        case HotelBasketActionType.SET_WAITING_FOR_FLIGHT:
            return Object.assign(Object.assign({}, state), { waitingForFlights: action.payload });
        case HotelBasketActionType.REMOVE_AVAILABILITY_ERRORS:
            return Object.assign(Object.assign({}, state), { availabilityErrors: state.availabilityErrors.filter((err) => err !== action.payload) });
        case HotelBasketActionType.SET_AVAILABILITY_ERRORS:
            return Object.assign(Object.assign({}, state), { waitingForFlights: action.payload !== HotelAvailabilityErrors.ROOM_ERROR ? false : state.waitingForFlights, waitingForRooms: action.payload !== HotelAvailabilityErrors.FLIGHT_ERROR ? false : state.waitingForRooms, availabilityErrors: [...state.availabilityErrors, action.payload] });
        case HotelBasketActionType.RESET_CONTEXT:
            return Object.assign(Object.assign({}, DEFAULT_HOTEL_BASKET), { estabId: state.estabId });
        case HotelBasketActionType.SET_ROOM_NOT_AVAILABLE:
            return Object.assign(Object.assign({}, state), { unavailableRoomIds: [...state.unavailableRoomIds, action.payload] });
        default:
            return state;
    }
}
